/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_Sentence_CaseInputs */

const en_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Sentence Case`)
};

const fr_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte en casse de phrase`)
};

const de_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text zu Satzgröße`)
};

const it_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo in caso di frase`)
};

const ru_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразование текста в предложение с использованием регистра`)
};

const es_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso de texto a oración`)
};

const zh_cn2_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本转句子大小写`)
};

const ja_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを文頭大文字に変換する`)
};

const hi_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ से सजा का मामला`)
};

const pt_pt2_text_to_sentence_case = /** @type {(inputs: Text_To_Sentence_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto para frase - Conversão de maiúsculas e minúsculas`)
};

/**
* | output |
* | --- |
* | "Text to Sentence Case" |
*
* @param {Text_To_Sentence_CaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_sentence_case = /** @type {((inputs?: Text_To_Sentence_CaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_Sentence_CaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_text_to_sentence_case(inputs)
	if (locale === "de") return de_text_to_sentence_case(inputs)
	if (locale === "it") return it_text_to_sentence_case(inputs)
	if (locale === "ru") return ru_text_to_sentence_case(inputs)
	if (locale === "es") return es_text_to_sentence_case(inputs)
	if (locale === "zh-CN") return zh_cn2_text_to_sentence_case(inputs)
	if (locale === "ja") return ja_text_to_sentence_case(inputs)
	if (locale === "hi") return hi_text_to_sentence_case(inputs)
	if (locale === "pt-PT") return pt_pt2_text_to_sentence_case(inputs)
	return en_text_to_sentence_case(inputs)
});